import cn from '@utils/cn';
import type { ReactNode } from 'react';
import { TipWrapper } from './TipWrapper';

interface Props {
  tabs: ReactNode[];
  activeIndex?: number;
  className?: string;
  tips?: string[];
  onChange: (index: number) => void;
}

function Tabbar({ tabs, activeIndex, className, tips = [], onChange }: Props) {
  return (
    <div
      className={cn(
        'flex h-35 w-full select-none items-center rounded border border-dark bg-black p-2',
        className
      )}
    >
      {tabs.map((title, i) => {
        const isActive = activeIndex === i;
        const tip = tips[i];
        return tip ? (
          <TipWrapper
            text={tip}
            key={i}
            className="h-full flex-1"
            offsetVal={5}
          >
            <div
              className={cn(
                'flex h-full cursor-pointer items-center justify-center rounded',
                {
                  'bg-blue text-white hover:bg-blue-active': isActive,
                  'text-black-gray hover:text-white': !isActive,
                }
              )}
              onClick={() => {
                if (isActive) return;
                onChange(i);
              }}
            >
              {title}
            </div>
          </TipWrapper>
        ) : (
          <div
            key={i}
            className={cn(
              'flex h-full flex-1 cursor-pointer items-center justify-center rounded',
              {
                'bg-blue text-white hover:bg-blue-active': isActive,
                'text-black-gray hover:text-white': !isActive,
              }
            )}
            onClick={() => {
              if (isActive) return;
              onChange(i);
            }}
          >
            {title}
          </div>
        );
      })}
    </div>
  );
}

export default Tabbar;
